import type { RechercheDossierQueryDTO, RechercheResultDTO } from '@/features/api/extranet/dto/Dossier/Recherche'
import { buildRechercheStore } from '../shared'

export const useRechercheDossierTtStore = buildRechercheStore<RechercheDossierQueryDTO, RechercheResultDTO>({
  storeName: 'rechercheDossierTtStore',
  apiPath: '/outilsfpe',
  location: {
    to: 'recherche',
    domaine: 'tt',
    module: 'dossier'
  }
})
